import $ from 'jquery';
import format from 'date-fns/format';
import isEqual from 'date-fns/isEqual';
import isAfter from 'date-fns/isAfter';
import isBefore from 'date-fns/isBefore';
import parse from 'date-fns/parse';
import parseISO from 'date-fns/parseISO';
import isMatch from 'date-fns/isMatch';
import addMinutes from 'date-fns/addMinutes';
import getMinutes from 'date-fns/getMinutes';
import setMinutes from 'date-fns/setMinutes';
import addHours from 'date-fns/addHours';
import getHours from 'date-fns/getHours';
import setHours from 'date-fns/setHours';
import { toZonedTime } from 'date-fns-tz';
import differenceInSeconds from 'date-fns/differenceInSeconds';
import differenceInMinutes from 'date-fns/differenceInMinutes';

const DateFns = {
  format,
  isEqual,
  isAfter,
  isBefore,
  toZonedTime,
  parse,
  parseISO,
  isMatch,
  addMinutes,
  getMinutes,
  setMinutes,
  addHours,
  getHours,
  setHours,
  differenceInSeconds,
  differenceInMinutes,
};

$.DateFns = DateFns;

export default DateFns;
